<script setup>
</script>
<template>
  <main
    class="mx-auto mb-[80px] mt-[60px] p-4 sm:w-[832px] sm:px-0 xl:mt-[70px]"
  >
    <div class="text-sm font-normal">
      <a href="https://upstox.com" target="_self" class="text-[#777777]"
        >Home</a
      >
      <!-- -->/<!-- -->
      <a class="text-[#777777]" href="/contact-us/">Contact Us</a>
      <!-- -->/ <span class="text-purple-base">Raise a Ticket</span>
    </div>
    <h1 class="inter-display-font mb-10 mt-8 text-2xl font-semibold leading-7">
      Raise a Ticket
    </h1>
    <div class="grid grid-cols-1 gap-x-16 gap-y-12 sm:grid-cols-1">
      <div>
        <div class="mb-6">
          <label
            class="mb-2 text-sm font-[500] block leading-5 !text-[16px] font-semibold leading-5 inter-display-font"
            for="mobile"
            >Mobile number<!-- -->
            <span class="text-red-500">*</span></label
          ><input
            id="mobile"
            name="mobile"
            placeholder="Enter your mobile number"
            class="mb-1 w-full rounded-lg border border-[#B1B1B1] px-3 py-2 text-xs font-normal leading-[18px] outline-none placeholder:text-[#777777] focus:outline-1 focus:outline-offset-0 focus:outline-[#D9D3E2] h-10"
            value=""
          />
        </div>
        <div class="mb-6">
          <label
            class="mb-2 text-sm font-[500] block leading-5 !text-[16px] font-semibold leading-5 inter-display-font"
            for="email"
            >Email address<!-- -->
            <span class="text-red-500">*</span></label
          ><input
            id="email"
            name="email"
            placeholder="Enter your email address"
            class="mb-1 w-full rounded-lg border border-[#B1B1B1] px-3 py-2 text-xs font-normal leading-[18px] outline-none placeholder:text-[#777777] focus:outline-1 focus:outline-offset-0 focus:outline-[#D9D3E2] h-10"
            value=""
          />
        </div>
        <div class="mb-6">
          <label
            class="mb-2 text-sm font-[500] block leading-5 !text-[16px] font-semibold leading-5 inter-display-font"
            for="subject"
            >Subject<!-- -->
            <span class="text-red-500">*</span></label
          ><input
            id="subject"
            name="subject"
            placeholder="Write subject for the ticket"
            class="mb-1 w-full rounded-lg border border-[#B1B1B1] px-3 py-2 text-xs font-normal leading-[18px] outline-none placeholder:text-[#777777] focus:outline-1 focus:outline-offset-0 focus:outline-[#D9D3E2] h-10"
            value=""
          />
        </div>
        <div class="mb-10">
          <label
            class="inter-display-font mb-2 block text-[16px] font-semibold leading-5"
            for="description"
            >Description <span class="text-red-500">*</span></label
          ><textarea
            id="description"
            name="description"
            placeholder="Write description for the ticket"
            class="mb-1 block w-full resize-none rounded-lg border border-[#B1B1B1] px-3 py-2 text-xs font-normal leading-[18px] outline-none placeholder:text-[#777777] focus:outline-1 focus:outline-offset-0 focus:outline-[#D9D3E2]"
            rows="3"
          ></textarea>
        </div>
        <div class="mb-6 flex items-center rounded-lg bg-[#F9F9F9] p-2">
          <img
            alt="time"
            loading="lazy"
            width="24"
            height="24"
            decoding="async"
            data-nimg="1"
            class="mr-2"
            style="color: transparent"
            src="@/styles/img/copilot-page-assets/contact-us/time-line.svg"
          />
          <p class="text-sm font-normal leading-5 text-[#777777]">
            Our team will respond within
          </p>
          <p class="ml-1 text-sm font-normal leading-5">24-48 business hrs</p>
        </div>
        <button
          type="button"
          class="h-10 w-[180px] !rounded-[100px] !border-[1px] text-xs font-bold !border-black !text-white"
        >
          Submit
        </button>
      </div>
    </div>
    <div
      class="custom-scroll-bar fixed bottom-0 right-0 z-30 flex flex-col overflow-x-hidden bg-white shadow-lg sm:bottom-[1%] sm:left-auto sm:right-[1%] sm:top-auto sm:mb-16 sm:rounded-lg duration-[350ms] transition-all h-0 w-0"
    >
      <div
        class="flex items-center justify-between bg-gradient-to-r from-purple-lighter to-purple-medium px-[16px] py-[16px] sm:rounded-t-lg md:py-[24px]"
      >
        <div>
          <span class="flex items-center gap-x-1.5"
            ><p class="text-lg font-semibold text-primary-base2">
              Welcome to Upstox support!
            </p>
            <span
              class="rounded-[4px] bg-[#61399F] bg-opacity-10 px-2 text-[13px] font-semibold text-purple-base"
              >BETA</span
            ></span
          >
        </div>
        <div class="flex gap-3">
          <div>
            <button
              class="cursor-pointer disabled:cursor-not-allowed text-white hover:bg-primary-dark active:bg-primary-dark2 disabled:bg-primary-base/50 rounded bg-primary-base2 px-2 py-1 text-sm font-medium not-italic"
            >
              Log In
            </button>
          </div>
        </div>
      </div>
      <div class="chat-box relative flex h-0 flex-grow">
        <div
          class="mr-[4px] w-full overflow-y-auto overflow-x-hidden p-4"
        ></div>
        <div
          class="absolute inset-x-0 z-20 flex justify-center transition-all duration-300 ease-in-out invisible -bottom-10 mb-12 opacity-0"
        >
          <button
            class="cursor-pointer disabled:cursor-not-allowed border border-primary-base text-primary-base hover:bg-primary-light disabled:border-primary-base/50 disabled:bg-white disabled:text-primary-base/50 flex h-8 items-center justify-center gap-0.5 rounded-full border-none bg-primary-light px-3 py-1 text-sm font-medium shadow-latest-chat active:bg-primary-light active:text-primary-base"
          >
            <img
              alt="latest chat"
              loading="lazy"
              width="16"
              height="16"
              decoding="async"
              data-nimg="1"
              class="h-4 w-4"
              style="color: transparent"
              src="@/styles/img/copilot-page-assets/contact-us/latest-chat-down-arrow.svg"
            /><span class="flex items-start">Latest chat</span>
          </button>
        </div>
      </div>
      <div
        class="z-50 border-t-[1px] border-primary-light-purple bg-purple-light2 px-2 pb-4 pt-0"
      >
        <div class="flex">
          <div
            class="flex flex-grow cursor-pointer items-center justify-between px-2 py-3"
          >
            <p class="text-[16px] font-semibold text-purple-base2">
              How can we help you?
            </p>
            <img
              alt="enter"
              loading="lazy"
              width="24"
              height="24"
              decoding="async"
              data-nimg="1"
              class="duration-250 transition-transform ease-in-out rotate-0"
              style="color: transparent"
              src="@/styles/img/copilot-page-assets/contact-us/down-arrow-purple.svg"
            />
          </div>
        </div>
        <div
          class="duration-250 overflow-hidden rounded-b-lg px-2 transition-[max-height] ease-in-out max-h-0"
        >
          <div class="grid select-none gap-2 grid-cols-3">
            <div
              class="cursor-pointer rounded-lg border border-purple-light3 bg-primary-light px-2.5 py-1.5 text-center text-[13px] font-medium leading-5 text-primary-base shadow-quick-query-1 hover:bg-primary-base hover:bg-opacity-10 hover:shadow-quick-query-2 col-span-1"
            >
              Top Queries
            </div>
            <div
              class="cursor-pointer rounded-lg border border-purple-light3 bg-primary-light px-2.5 py-1.5 text-center text-[13px] font-medium leading-5 text-primary-base shadow-quick-query-1 hover:bg-primary-base hover:bg-opacity-10 hover:shadow-quick-query-2 col-span-1"
            >
              Accounts
            </div>
            <div
              class="cursor-pointer rounded-lg border border-purple-light3 bg-primary-light px-2.5 py-1.5 text-center text-[13px] font-medium leading-5 text-primary-base shadow-quick-query-1 hover:bg-primary-base hover:bg-opacity-10 hover:shadow-quick-query-2 col-span-1"
            >
              Wallet
            </div>
            <div
              class="cursor-pointer rounded-lg border border-purple-light3 bg-primary-light px-2.5 py-1.5 text-center text-[13px] font-medium leading-5 text-primary-base shadow-quick-query-1 hover:bg-primary-base hover:bg-opacity-10 hover:shadow-quick-query-2 col-span-1"
            >
              Trading
            </div>
            <div
              class="cursor-pointer rounded-lg border border-purple-light3 bg-primary-light px-2.5 py-1.5 text-center text-[13px] font-medium leading-5 text-primary-base shadow-quick-query-1 hover:bg-primary-base hover:bg-opacity-10 hover:shadow-quick-query-2 col-span-1"
            >
              Referral
            </div>
          </div>
          <div class="flex select-none flex-wrap gap-2 pb-3"></div>
        </div>
        <div class="flex items-end gap-x-2 px-2">
          <textarea
            rows="1"
            placeholder="Write your query here"
            class="flex-grow cursor-pointer resize-none rounded border px-3 py-2 text-sm outline-none focus:border-gray-lightBorder/[0.2] focus:shadow-copilot-input border-primary-light"
          ></textarea
          ><button
            class="cursor-pointer text-sm font-semibold disabled:cursor-not-allowed bg-primary-base text-white hover:bg-primary-dark active:bg-primary-dark2 disabled:bg-primary-base/50 rounded p-2.5"
            disabled=""
          >
            <div class="select-none">
              <img
                alt="enter"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                style="color: transparent"
                src="@/styles/img/copilot-page-assets/contact-us/right-arrow-light.svg"
              />
            </div>
          </button>
        </div>
      </div>
    </div>
  </main>
</template>
<style scoped>
</style>
